import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {
  Header,
  Grid,
  Container,
  Divider,
  Image,
  Table,
  Modal,
  Dimmer,
  Loader,
  List,
  Checkbox,
  Button,
  Accordion,
  Icon
} from "semantic-ui-react"
import VehicleModal from "./VehicleModal"
import { StateNamesAndAbbreviations } from "../../constants/states"
import * as vehicleHelpers from "../../helpers/vehicleHelpers"
import { withTranslation } from "react-i18next"
import {
  isFleetcor,
  isFleetMaintenanceHub,
  isFleetMaintenanceHubCanada
} from "../../helpers/affiliationHelpers"
import { isEmpty } from "lodash"
import DocumentUploadModal from "./DocumentUploadModal"
import userIcon from "../../assets/images/driver_license_uploded.svg"
import documentIcon from "../../assets/images/custom_document.svg"
import { DRIVER } from "../../constants/roles"
import moment from "moment"
import { Date_Format } from "../../constants/years"
import { DOCUMENT_TYPE, FLEETCOR } from "../../constants/application"
import GeotabInfo from "./GeotabInfo"
import { ON } from "../config/SplitClient"
import { OIL_CHANGE } from "../../constants/services"
import { EDIT } from "../../constants/application"
import TreadDepth from "./TreadDepth"
import { getSubdomain } from "../shared/StylesheetInjector"

class VehicleInfo extends Component {
  static propTypes = {
    vehicle: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      openDocumentModal: false,
      docType: "",
      openManageDriversModal: false,
      driversList: [],
      isLoadingDrivers: false,
      selectedDriverIds: [],
      initialSelectedDriverIds: [],
      isDriversAccordionOpen: false
    }
  }

  handleDocumentView = (docType) => {
    this.setState({
      openDocumentModal: true,
      docType
    })
    this.props.dispatch({ type: "CLEAR_DOCUMENT_UPLOAD_MESSAGE" })
  }

  handleDocumentUpload = (docType) => {
    this.setState({
      openDocumentModal: true,
      docType
    })
    this.props.dispatch({ type: "CLEAR_DOCUMENT_UPLOAD_MESSAGE" })
  }

  handleDriverAccordionClick = () => {
    this.setState((prevState) => ({ isDriversAccordionOpen: !prevState.isDriversAccordionOpen }))
  }

  updateDriverLienseState = (value) => {
    this.setState({ openDocumentModal: value })
  }

  renderViewOrUploadDocumentLink = (
    document,
    displayInline,
    icon,
    viewOnClick,
    uploadOnClick,
    docType
  ) => {
    const { userRoles = [], t } = this.props
    const isUserOnlyDriver = userRoles.length === 1 ? userRoles[0] === DRIVER : false
    return !isEmpty(document) ? (
      <>
        <Image src={icon} style={displayInline} onClick={() => viewOnClick(docType)} />
        &nbsp;&nbsp;
        <span className="link" onClick={() => viewOnClick(docType)}>
          {t("viewLabel")}
        </span>
      </>
    ) : isUserOnlyDriver && docType !== DOCUMENT_TYPE.DRIVER_LICENSE ? (
      <>
        <Image src={icon} style={{ ...displayInline, ...{ cursor: "not-allowed" } }} />
        &nbsp;&nbsp;
        <span style={{ cursor: "not-allowed" }}>{t("uploadLabel")}</span>
      </>
    ) : (
      <>
        <Image src={icon} style={displayInline} onClick={() => uploadOnClick(docType)} />
        &nbsp;&nbsp;
        <span className="link" onClick={() => uploadOnClick(docType)}>
          {t("uploadLabel")}
        </span>
      </>
    )
  }

  renderDocumentModal = () => {
    const { openDocumentModal, docType } = this.state
    const {
      vehicle,
      driverLicence,
      states,
      dispatch,
      userFirstName,
      vehicleInsurance,
      registration,
      customDocuments,
      userRoles
    } = this.props
    return (
      <DocumentUploadModal
        open={openDocumentModal}
        showOrHideModal={this.updateDriverLienseState}
        states={states}
        dispatch={dispatch}
        vehicleId={vehicle.id}
        driverLicence={driverLicence}
        vehicleInsurance={vehicleInsurance}
        registration={registration}
        docType={docType}
        userFirstName={userFirstName}
        customDocuments={customDocuments}
        userRoles={userRoles}
      />
    )
  }

  handleManageDriversClick = () => {
    this.setState({
      openManageDriversModal: true,
      isLoadingDrivers: true,
      selectedDriverIds: [],
      initialSelectedDriverIds: []
    })
    this.props.dispatch({
      type: "LOAD_DRIVERS",
      callback: (status, data) => {
        if (status === "success") {
          let initialSelected = []
          const { vehicle, driverInfo } = this.props

          if (vehicle && vehicle.users && Array.isArray(vehicle.users)) {
            initialSelected = vehicle.users.map((u) => u.id)
          } else {
            let emails = []
            if (driverInfo && driverInfo.emailAddress) {
              emails = Array.isArray(driverInfo.emailAddress)
                ? driverInfo.emailAddress
                : [driverInfo.emailAddress]
            } else if (vehicle && vehicle.driver_emails) {
              emails = Array.isArray(vehicle.driver_emails)
                ? vehicle.driver_emails
                : [vehicle.driver_emails]
            }
            initialSelected = data
              .filter((d) => d.email && emails.includes(d.email))
              .map((d) => d.id)
          }

          const sortedDriversList = (data || []).sort((a, b) => {
            const nameA = a.firstName || a.first_name || a.name || ""
            const nameB = b.firstName || b.first_name || b.name || ""
            return nameA.localeCompare(nameB)
          })

          this.setState({
            driversList: sortedDriversList,
            isLoadingDrivers: false,
            selectedDriverIds: initialSelected,
            initialSelectedDriverIds: [...initialSelected]
          })
        } else {
          this.setState({ isLoadingDrivers: false })
        }
      }
    })
  }

  handleDriverCheckboxChange = (driverId, checked) => {
    this.setState((prevState) => {
      const { selectedDriverIds } = prevState
      if (checked) {
        return { selectedDriverIds: [...selectedDriverIds, driverId] }
      } else {
        return { selectedDriverIds: selectedDriverIds.filter((id) => id !== driverId) }
      }
    })
  }

  handleManageDriversSubmit = () => {
    const { selectedDriverIds, initialSelectedDriverIds, driversList } = this.state
    const { vehicle, dispatch } = this.props

    this.setState({ isLoadingDrivers: true })

    const addedOrRetainedAttributes = selectedDriverIds
      .filter((id) => !initialSelectedDriverIds.includes(id))
      .map((id) => ({
        active_owner: true,
        customer_id: id
      }))

    const removedDriverIds = initialSelectedDriverIds.filter(
      (id) => !selectedDriverIds.includes(id)
    )
    const removedAttributes = removedDriverIds
      .map((id) => {
        const driver = driversList.find((u) => u.id === id)
        const ownerVehicleId =
          driver?.active_owner_vehicles?.find(
            (u) => u.customer_id === id && u.vehicle_id === vehicle.id
          )?.id ?? null

        if (ownerVehicleId) {
          return {
            id: ownerVehicleId,
            _destroy: "1"
          }
        }
        return null
      })
      .filter((attr) => attr !== null)

    dispatch({
      type: "VEHICLE_CREATE_OR_UPDATE_SAGA_V6",
      payload: {
        formData: {
          id: vehicle.id,
          owner_vehicles_attributes: [...addedOrRetainedAttributes, ...removedAttributes]
        }
      },
      callback: (status) => {
        this.setState({ isLoadingDrivers: false, openManageDriversModal: false })
        if (status === "success") {
          dispatch({
            type: "VEHICLE_LOAD_SAGA",
            payload: {
              vehicleId: vehicle.id,
              options: {
                dataType: "extended"
              }
            }
          })
        }
      }
    })
  }

  closeManageDriversModal = () => {
    this.setState({ openManageDriversModal: false })
  }

  renderManageDriversModal = () => {
    const { openManageDriversModal, isLoadingDrivers, driversList, selectedDriverIds } = this.state

    return (
      <Modal
        open={openManageDriversModal}
        onClose={this.closeManageDriversModal}
        closeIcon
        size="mini"
        className="driver-list-modal"
      >
        <Modal.Content scrolling>
          <p>
            <b>Assign one or more drivers to this vehicle</b>
          </p>
          {isLoadingDrivers ? (
            <Dimmer active inverted>
              <Loader inverted content="Loading" />
            </Dimmer>
          ) : driversList && driversList.length > 0 ? (
            <List divided relaxed>
              {driversList.map((driver, index) => (
                <List.Item key={index}>
                  <List.Content
                    floated="left"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      paddingTop: "5px"
                    }}
                  >
                    <Checkbox
                      className={"checkbox"}
                      checked={selectedDriverIds.includes(driver.id)}
                      onChange={(e, { checked }) =>
                        this.handleDriverCheckboxChange(driver.id, checked)
                      }
                    />
                  </List.Content>
                  <List.Content>
                    <List.Header>
                      {driver.name ||
                        `${driver.firstName || driver.first_name || ""} ${
                          driver.lastName || driver.last_name || ""
                        }`.trim()}
                    </List.Header>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          ) : (
            <p>No drivers found.</p>
          )}
          <Button
            fluid
            className={"driver-list-button"}
            onClick={this.handleManageDriversSubmit}
            disabled={isLoadingDrivers}
          >
            Save Changes
          </Button>
        </Modal.Content>
      </Modal>
    )
  }

  render() {
    const {
      vehicle,
      loadVehicle,
      language,
      t,
      driverLicence,
      vehicleInsurance,
      registration,
      customDocuments,
      isGloveboxFeatureFlag,
      dispatch,
      engineOilData,
      tirePressureAndTempData,
      batteryLifeData,
      faultCodesData,
      isLoading,
      isGeotabSectionFlag,
      serviceSchedulesByVehicle,
      faultCodeService,
      driverInfo
    } = this.props

    let state = StateNamesAndAbbreviations.find(
      (s) => s.abbreviation === vehicle.license_plate_state
    )
    const serviceSchedule = (serviceSchedulesByVehicle[vehicle.id] || [])
      .filter((upcomingService) => upcomingService.recommended)
      .find((upcomingService) => upcomingService.name === OIL_CHANGE)
    const isFleetShellCanada = isFleetMaintenanceHubCanada()
    const displayFlex = { display: "flex" }
    const displayInline = { display: "inline", cursor: "pointer" }
    const { openDocumentModal } = this.state

    const sortedDriverInfo =
      driverInfo?.driverName?.length > 0
        ? driverInfo.driverName
            .map((name, index) => ({
              name,
              phone: driverInfo.mobilePhoneNumber?.[index],
              email: driverInfo.emailAddress?.[index]
            }))
            .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
        : []

    return (
      <div>
        <Header size="medium">
          {t("vehicleInformationLabel")}&nbsp;&nbsp;&nbsp;
          <VehicleModal completionCallback={loadVehicle} vehicle={vehicle}>
            <span className="link">{t("common:editLabel")}</span>
          </VehicleModal>
        </Header>
        <Grid>
          <Grid.Column width={8}>
            <Grid padded="horizontally">
              <Grid.Column width={8}>
                <p className="vehicle_field">
                  {t("yearLabel")}: <span>{vehicle.year || "-"}</span>
                </p>
                <p className="vehicle_field">
                  {t("makeLabel")}: <span>{vehicle.make || "-"}</span>
                </p>
                <p className="vehicle_field">
                  {t("modelLabel")}: <span>{vehicle.model || "-"}</span>
                </p>
                {isFleetcor() && (
                  <p className="vehicle_field">
                    {t("cardName")}: <span>{vehicle.name_of_vehicle || "-"}</span>
                  </p>
                )}
                {isFleetcor() && (
                  <p className="vehicle_field">
                    {t("otherIDLabel")}: <span>{vehicle.other_id || "-"}</span>
                  </p>
                )}
              </Grid.Column>
              <Grid.Column width={8}>
                <p className="vehicle_field">
                  {t("vinLabel")}: <span>{vehicle.vin || "-"}</span>
                </p>
                <p className="vehicle_field">
                  {isFleetShellCanada
                    ? `${t("dashboard:mileageLabel")}`
                    : `${t("dashboard:milesLabel")}`}
                  : <span>{vehicleHelpers.formattedMiles(vehicle)}</span>
                </p>
                <p className="vehicle_field">
                  {t("dashboard:plateLabel")} #:{" "}
                  <span>{vehicleHelpers.formattedLicensePlateNumber(vehicle)}</span>
                </p>
              </Grid.Column>
              <Grid.Column width={8}>
                <p className="vehicle_field">
                  {isFleetShellCanada ? (
                    <>
                      CPK: <span>${vehicleHelpers.formattedCostPerMile(vehicle)} CAD</span>
                    </>
                  ) : (
                    <>
                      CPM: <span>${vehicleHelpers.formattedCostPerMile(vehicle)}</span>
                    </>
                  )}
                </p>
                <p className="vehicle_field">
                  {isFleetShellCanada ? t("provinceLabel") : t("stateLabel")}:{" "}
                  <span>{(state && state.name) || vehicle.license_plate_state || "-"}</span>
                </p>
                <p className="vehicle_field">
                  {t("lastMaintenanceLabel")}:{" "}
                  <span>{vehicleHelpers.formattedLastMaintenanceDate(vehicle, language)}</span>
                </p>
              </Grid.Column>
              <Grid.Column width={8}>
                {!isFleetShellCanada ? (
                  <p className="vehicle_field">
                    {t("expirationDateLabel")}
                    {": "}
                    <span>{vehicleHelpers.formattedLicensePlateExpiration(vehicle, language)}</span>
                  </p>
                ) : null}
                <p className="vehicle_field">
                  {t("departmentNumber")}: <span>{vehicle.department_number}</span>
                </p>
                {!isFleetcor() && (
                  <p className="vehicle_field">
                    {t("otherIDLabel")}: <span>{vehicle.other_id || "-"}</span>
                  </p>
                )}
              </Grid.Column>
            </Grid>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid>
              <Grid.Column width={10}>
                <TreadDepth />
              </Grid.Column>
              <Grid.Column width={6} container alignItems="center" justify="center">
                <Image size="medium" src={vehicle.dashboard_url || "/images/no_car_large.svg"} />
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid>
        {isGeotabSectionFlag &&
        isGeotabSectionFlag === ON &&
        vehicle &&
        vehicle.geotab_device_id !== null ? (
          <>
            <Divider />
            <GeotabInfo
              engineOilData={engineOilData}
              tirePressureAndTempData={tirePressureAndTempData}
              batteryLifeData={batteryLifeData}
              faultCodesData={faultCodesData}
              serviceSchedule={serviceSchedule}
              vehicle={vehicle}
              faultCodeService={faultCodeService}
            />
          </>
        ) : (
          <></>
        )}
        <Divider />
        <Accordion>
          <Accordion.Title
            active={this.state.isDriversAccordionOpen}
            onClick={this.handleDriverAccordionClick}
          >
            <Header style={{ display: "inline-block", marginBottom: 0 }}>
              <Icon name="dropdown" />
              {t("Drivers")} (
              {driverInfo?.driverName?.length > 0 ? driverInfo?.driverName?.length : "0"})
            </Header>
          </Accordion.Title>
          <Accordion.Content active={this.state.isDriversAccordionOpen}>
            <Table className="borderless">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t("driverNameLabel")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("mobilePhoneNumberLabel")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("emailAddressLabel")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {sortedDriverInfo.length > 0 ? (
                  sortedDriverInfo.map((driver, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{driver.name || "N/A"}</Table.Cell>
                      <Table.Cell>{formatPhoneNumber(driver.phone || "N/A")}</Table.Cell>
                      <Table.Cell>{driver.email || "N/A"}</Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell>N/A</Table.Cell>
                    <Table.Cell>N/A</Table.Cell>
                    <Table.Cell>N/A</Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </Accordion.Content>
        </Accordion>

        <span
          className="link"
          onClick={this.handleManageDriversClick}
          style={{ display: "inline-block", marginBottom: "15px" }}
        >
          Manage Drivers
        </span>
        {this.renderManageDriversModal()}

        {isGloveboxFeatureFlag && isGloveboxFeatureFlag === ON && (
          <>
            <Divider />
            <Header>{t("gloveboxHeaderLbl")}</Header>
            <Grid compact columns="equal" padded="horizontally">
              <Grid.Column>
                <p style={displayFlex}>
                  {t("vehicleInsuranceLabel")}:&nbsp;
                  {this.renderViewOrUploadDocumentLink(
                    vehicleInsurance,
                    displayInline,
                    documentIcon,
                    this.handleDocumentView,
                    this.handleDocumentUpload,
                    DOCUMENT_TYPE.VEHICLE_INSURANCE
                  )}
                </p>
                <p>
                  {t("expirationDateLabel")}
                  {": "}
                  {!isEmpty(vehicleInsurance.expiration_date) ? (
                    <b>
                      {moment(vehicleInsurance.expiration_date).format(
                        isFleetShellCanada ? Date_Format.YYYY_MM_DD : Date_Format.MM_DD_YYYY
                      )}
                    </b>
                  ) : (
                    <b>{t("notAvailableLabel")}</b>
                  )}
                </p>
              </Grid.Column>
              <Grid.Column>
                <p style={displayFlex}>
                  {t("registrationLabel")}:&nbsp;
                  {this.renderViewOrUploadDocumentLink(
                    registration,
                    displayInline,
                    documentIcon,
                    this.handleDocumentView,
                    this.handleDocumentUpload,
                    DOCUMENT_TYPE.REGISTRATION
                  )}
                </p>
                <p>
                  {t("expirationDateLabel")}
                  {": "}
                  {!isEmpty(registration.expiration_date) ? (
                    <b>
                      {moment(registration.expiration_date).format(
                        isFleetShellCanada ? Date_Format.YYYY_MM_DD : Date_Format.MM_DD_YYYY
                      )}
                    </b>
                  ) : (
                    <b>{t("notAvailableLabel")}</b>
                  )}
                </p>
              </Grid.Column>
              <Grid.Column>
                <p>
                  {t("extraDocumentsLable")}:&nbsp;
                  {this.renderViewOrUploadDocumentLink(
                    customDocuments,
                    displayInline,
                    documentIcon,
                    this.handleDocumentView,
                    this.handleDocumentUpload,
                    DOCUMENT_TYPE.OTHER
                  )}
                </p>
                <p>
                  {t("totalDocumentsLabel")}:{" "}
                  {!isEmpty(customDocuments) ? <b>{customDocuments.length}</b> : <b>0</b>}
                </p>
              </Grid.Column>
            </Grid>
            {openDocumentModal ? this.renderDocumentModal() : null}
          </>
        )}
      </div>
    )
  }
} // class VehicleInfo

const mapStateToProps = (state) => ({
  language: state.users.currentUser && state.users.currentUser.language,
  userFirstName: state.users.currentUser && state.users.currentUser.firstName,
  userRoles:
    (state.application.userSessionData && state.application.userSessionData.roles) ||
    (state.users.currentUser && state.users.currentUser.roles),
  states: state.users.states,
  affiliation: state.affiliations.affiliation
})
const formatPhoneNumber = (phone) => {
  const digits = String(phone).replace(/\D/g, "") // strip non‑digits
  if (digits.length !== 10) return String(phone)
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
}
export default connect(mapStateToProps)(withTranslation("vehicle")(VehicleInfo))
